import { BASE_API_URL } from '../constants'
import Token from './Token'

export const UserWalletApi = {
    get: () => {
        return fetch(BASE_API_URL + '/api/user-wallet', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
            },
        }).then((r) => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    put: (walletId) => {
        return fetch(BASE_API_URL + '/api/user-wallet', {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ paymentMethodID: walletId }),
        }).then((r) => {
            if (r.ok) {
                return r
            }
            if (r.status === 400) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    createClientSecret: () => {
        return fetch(BASE_API_URL + '/api/user-wallet/create-setup-intent', {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
            },
        }).then((r) => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    delete: (walletId) => {
        return fetch(BASE_API_URL + '/api/user-wallet/' + walletId, {
            method: 'DELETE',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
                'Content-Type': 'application/json',
            },
        }).then((r) => {
            if (r.ok) {
                return r
            }
            throw new Error(r.statusText)
        })
    },
}
